export default "__VITE_ASSET__DkPGMk9J__"